"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GlobalNavigationMenu_component_exports = {};
__export(GlobalNavigationMenu_component_exports, {
  GlobalNavigationMenu: () => GlobalNavigationMenu
});
module.exports = __toCommonJS(GlobalNavigationMenu_component_exports);
var import_styled_components = __toESM(require("styled-components"));
var import_react = __toESM(require("react"));
var import_useBreakpoints = require("../../../../utils/useBreakpoints/useBreakpoints.hook");
var import_IconButtonDropdown = require("../../IconButtonDropdown/IconButtonDropdown.component");
var import_icominds_lib = require("@greatmindsorg/icominds-lib");
var import_TabList = require("../../TabList/TabList.component");
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } }));
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
var GlobalNavigationMenu = function GlobalNavigationMenu2(_ref) {
  var items = _ref.items, tablist = _ref.tablist, className = _ref.className, handleOnChange = _ref.handleOnChange;
  var _useBreakpoints = (0, import_useBreakpoints.useBreakpoints)(), isLg = _useBreakpoints.isLg, isXl = _useBreakpoints.isXl;
  var twSelected = "aria-[current=true]";
  return isLg || isXl ? /* @__PURE__ */ import_react.default.createElement(_StyledDiv, {
    className,
    $_css: [{
      "display": "flex",
      "height": "100%",
      "width": "100%",
      "alignItems": "flex-end",
      "alignSelf": "flex-end"
    }]
  }, /* @__PURE__ */ import_react.default.createElement(_StyledDiv2, {
    $_css2: [{
      "borderWidth": "1px",
      "borderRightWidth": "0px",
      "borderStyle": "solid",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(204 204 204 / var(--tw-border-opacity))"
    }, {
      "marginRight": "1rem",
      "display": "inline-block",
      "height": "50%",
      "alignSelf": "center",
      "--tw-text-opacity": "1",
      "color": "rgb(204 204 204 / var(--tw-text-opacity))"
    }]
  }), /* @__PURE__ */ import_react.default.createElement(import_TabList.TabList, _extends({
    role: "navigation",
    variant: "transparent",
    handleOnChange
  }, tablist), items.map(function(item) {
    return /* @__PURE__ */ import_react.default.createElement(import_TabList.TabList.LinkTab, _extends({
      key: item.id,
      navStrategy: "browserDefault",
      customStyle: [
        {
          "boxSizing": "content-box",
          "paddingTop": "0.5rem",
          "paddingBottom": "0.5rem"
        },
        /* Hover */
        {
          "&:hover": {
            "--tw-bg-opacity": "1",
            "backgroundColor": "rgb(250 251 249 / var(--tw-bg-opacity))",
            "--tw-text-opacity": "1",
            "color": "rgb(51 51 51 / var(--tw-text-opacity))",
            "textDecorationLine": "none"
          }
        },
        /* Focus */
        {
          "&:focus": {
            "borderRadius": "0",
            "--tw-shadow": "0 0 #0000",
            "--tw-shadow-colored": "0 0 #0000",
            "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
          }
        },
        {
          "&:focus > *": {
            "borderRadius": "0",
            "--tw-text-opacity": "1",
            "color": "rgb(24 24 24 / var(--tw-text-opacity))",
            "textDecorationLine": "none"
          }
        },
        {
          "&:focus": {
            "outlineStyle": "solid",
            "outlineWidth": "2px",
            "outlineOffset": "-3px",
            "outlineColor": "#706C5C"
          }
        },
        /* Selected */
        {
          '&[aria-current="true"]': {
            "fontWeight": "900",
            "--tw-shadow": "0 0 #0000",
            "--tw-shadow-colored": "0 0 #0000",
            "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
          }
        },
        {
          '&[aria-current="true"]': {
            "borderWidth": "0px",
            "borderBottomWidth": "4px",
            "borderStyle": "solid",
            "--tw-border-opacity": "1",
            "borderColor": "rgb(112 108 92 / var(--tw-border-opacity))"
          }
        }
      ],
      id: item.id,
      title: item.title
    }, item));
  }))) : /* @__PURE__ */ import_react.default.createElement(import_IconButtonDropdown.IconButtonDropdown, {
    ariaLabel: tablist.ariaLabel,
    className,
    icon: "hamburguer",
    listPlacement: "bottom-end",
    list: items.map(function(item) {
      var isSelected = tablist.defaultSelected.id === item.id;
      return {
        id: item.id,
        handleOnSelect: handleOnChange || function() {
          return window.location.assign(item.href);
        },
        ariaSelected: isSelected,
        disabled: item.isDisabled,
        tooltip: item === null || item === void 0 ? void 0 : item.tooltip,
        children: /* @__PURE__ */ import_react.default.createElement(_StyledDiv3, null, /* @__PURE__ */ import_react.default.createElement("span", null, item.title), isSelected && /* @__PURE__ */ import_react.default.createElement(import_icominds_lib.Icon, {
          name: "check",
          size: 20
        }))
      };
    })
  });
};
GlobalNavigationMenu.displayName = "GlobalNavigationMenu";
var _StyledDiv = (0, import_styled_components.default)("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function(p) {
  return p.$_css;
});
var _StyledDiv2 = (0, import_styled_components.default)("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function(p) {
  return p.$_css2;
});
var _StyledDiv3 = (0, import_styled_components.default)("div").withConfig({
  displayName: "GlobalNavigationMenucomponent___StyledDiv3",
  componentId: "sc-166o778-0"
})({
  "display": "flex",
  "width": "10rem",
  "justifyContent": "space-between",
  "textAlign": "left",
  "@media (min-width: 680px)": {
    "width": "20rem"
  }
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  GlobalNavigationMenu
});
//# sourceMappingURL=GlobalNavigationMenu.component.js.map